import type { SVGProps } from 'react'
const SvgSyOnButton = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M10.5 6.576c0-.18 0-.27-.062-.315s-.144-.018-.31.036a6 6 0 1 0 3.743 0c-.164-.054-.247-.08-.309-.036s-.062.135-.062.315V9a1.5 1.5 0 0 1-3 0z"
			clipRule="evenodd"
		/>
		<path d="M12 3.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5" />
		<path d="M18.01 5.49a.5.5 0 0 0-.354.147.5.5 0 0 0 0 .707A7.998 7.998 0 0 1 12 20a8 8 0 0 1-4.445-1.348A8 8 0 0 1 6.344 6.344a.5.5 0 0 0 0-.707.5.5 0 0 0-.707 0A8.998 8.998 0 0 0 17 19.482a9 9 0 0 0 1.363-13.845.5.5 0 0 0-.353-.147" />
	</svg>
)
export default SvgSyOnButton
